import { useState } from 'react';

import Instagram from '../../../assets/icons/trvto_instagram.svg';
import Whatsapp from '../../../assets/icons/trvto_whatsapp.svg';
import Copy from '../../../assets/icons/trvto_copy.svg';
import Location from '../../../assets/icons/trvto_location.svg';
import User from '../../../assets/icons/trvto_userCount.svg';

import { formatPhone } from '../../../utils/formatPhoneNumber';
import { AssignmentModal } from './AssignedDetails';

const Header = ({ user, getStatus, supportUsers = [], assigning = false, onAssign, isSuperAdmin = false }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [searchText, setSearchText] = useState('');

    const assignedUser = user?.assignedSupportId;

    const getInitials = (name = '') => {
        return name
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map((item) => item[0])
            .join('')
            .toUpperCase();
    };

    const formatDate = (date) => {
        if (!date) return '-';

        return new Date(date).toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const filteredUsers = supportUsers.filter((supportUser) => {
        const currentAssignedId = assignedUser?._id?.toString();
        const supportUserId = supportUser?._id?.toString();

        // Don't show currently assigned user
        if (currentAssignedId && supportUserId === currentAssignedId) {
            return false;
        }

        const search = searchText.toLowerCase().trim();

        if (!search) return true;

        return (
            supportUser?.name?.toLowerCase().includes(search) ||
            supportUser?.emailId?.toLowerCase().includes(search) ||
            String(supportUser?.phoneNumber || '').includes(search)
        );
    });

    const closeModal = () => {
        setShowModal(false);
        setSelectedUserId('');
        setSearchText('');
    };

    const handleAssign = async () => {
        if (!selectedUserId || !onAssign) return;

        await onAssign(selectedUserId);

        setSelectedUserId('');
        setSearchText('');
        setShowModal(false);
    };

    const openAssignmentModal = () => {
        setSelectedUserId('');
        setSearchText('');
        setShowModal(true);
    };

    return (
        <>
            <div className='drawerHeader'>
                {/* LEFT */}
                <div className='headerLeft'>
                    <div className='drawerAvatar'>{user?.name?.charAt(0) || 'U'}</div>

                    <div className='userInfo'>
                        <div className='nameRow'>
                            <h2>{user?.name || 'Anonymous'}</h2>

                            <img src={user?.platform === 'instagram' ? Instagram : Whatsapp} width={22} alt='' />
                        </div>

                        <div className='phoneRow'>
                            <span>
                                {user?.platform === 'instagram' ? user?.igUserId : formatPhone(user?.phoneNumber)}
                            </span>

                            <img src={Copy} width={18} alt='Copy' style={{ cursor: 'pointer' }} />
                        </div>

                        <div className='phoneRow'>
                            <img src={Location} width={17} alt='' />

                            <span className='locationText'>{user?.selectedCity || 'Unknown'}, Karnataka</span>
                        </div>
                    </div>
                </div>

                {/* RIGHT */}
                {isSuperAdmin && (
                    <div className='headerRight'>
                        {assignedUser ? (
                            <div className='assignedUserCompact'>
                                <div className='assignedUserHeading'>Assigned To</div>

                                <div className='assignedUserRow'>
                                    <div className='assignedAvatarTop'>
                                        <img src={User} width={17} alt='' />
                                    </div>

                                    <div className='assignedUserInfo'>
                                        <div className='assignedUserName'>
                                            <span>{assignedUser?.name}</span>

                                            <span className='assignedStatusDot' />
                                        </div>

                                        <div className='assignedUserRole'>{assignedUser?.access || 'Support'}</div>
                                    </div>

                                    <button
                                        type='button'
                                        className='editAssignedBtn'
                                        onClick={openAssignmentModal}
                                        title='Change assigned user'
                                    >
                                        ✏️
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className='assignedUserCompact unassigned'>
                                <div className='assignedUserHeading'>Assigned To</div>

                                <div className='assignedUserRow'>
                                    <span className='notAssignedText'>Not assigned</span>

                                    {isSuperAdmin && (
                                        <button
                                            type='button'
                                            className='editAssignedBtn'
                                            onClick={openAssignmentModal}
                                            title='Assign user'
                                        >
                                            ✏️
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* ASSIGNMENT MODAL */}
            <AssignmentModal
                showModal={showModal}
                closeModal={closeModal}
                assignedUser={assignedUser}
                user={user}
                filteredUsers={filteredUsers}
                searchText={searchText}
                setSearchText={setSearchText}
                selectedUserId={selectedUserId}
                setSelectedUserId={setSelectedUserId}
                assigning={assigning}
                handleAssign={handleAssign}
                getInitials={getInitials}
                formatDate={formatDate}
            />
        </>
    );
};

export default Header;
